<template>
  <el-container class="page-x" direction="vertical">
    <div class="search-x">
      <!--添加权限码-->
      <button class="file-button"
          >批量导入（不同人）
          <input 
            class="file-item"
            type='file' 
            title=""
            accept="application/pdf"  
            multiple="multiple"
            webkitdirectory
            @change="chooseEqualFile"></button
        >
      <button class="file-button"
          >批量导入（同一人）
          <input 
            class="file-item"
            type='file' 
            title=""
            accept="application/pdf"  
            multiple="multiple"
            webkitdirectory
            @change="chooseNoEqualFile"></button
        >
      <el-button v-auth="'sa_exam_report_page'" type="primary" @click="dialogVisibleImport=true"
        >帮助说明</el-button
      >

    </div>
    <div class="cont-x" ref="tableBox" >
      <p class="import-title">导入记录</p>
      <div class="table-x" >
        <el-table v-loading="loading" :data="tableData" :height="tableHeight" border class="mb20">
          <el-table-column type="index" align="center" label="序号" width="100">
          </el-table-column>
          <el-table-column prop="createTime" align="center" label="导入时间">
          </el-table-column>
          <el-table-column prop="total" align="center" label="导入数量">
          </el-table-column>
          <el-table-column prop="status" align="center" label="导入状态">
            <template slot-scope="scope">
              <span >{{ scope.row.status | filterValue(statusList) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="cardNo" align="center" label="失败数">
            <template slot-scope="scope">
              <el-tooltip v-if="scope.row.failList.length > 0" placement="top" effect="light">
                <div slot="content">
                  <p v-html="scope.row.failNames"></p>
                </div>
                <span>{{ scope.row.failList.length }}</span>
              </el-tooltip>
              <span v-else>{{ scope.row.failList.length }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="adminName" align="center" label="操作人">
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="pagenation-x">
      <div class="pagination mb20">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="searchBox.pageNo"
          @size-change="handleSizeChange"
          :page-sizes="[10,50,100]"
          :page-size="searchBox.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          background
          > 
        </el-pagination>
      </div>
    </div>
    <el-dialog
      title="帮助说明"
      :visible.sync="dialogVisibleImport"
      width="50%"
      center
      >
      <div class="help-content">
        <el-card shadow="always" style="width: 38%;">
          <p style="font-weight: bold;">导入不同人：</p>
          <p>选择文件夹，文件夹命名无要求</p>
          <p></p>
          <p>文件夹内，文件命名规则如下：</p>
          <p>1、文件格式必须是PDF</p>
          <p>2、文件名称必须是：<br>姓名+身份证号码+报告机构</p>
          <p>例如：张某_225524199808041354_爱康.pdf</p>
          <p>注：单文件夹最多支持{{ maxUploadNum }}份报告</p>
        </el-card>
        <el-card shadow="always" style="width: 38%;">
          <p style="font-weight: bold;">导入相同人：</p>
          <p>选择文件夹，文件夹命名有要求</p>
          <p>1、文件夹名称必须是</p>
          <p>姓名+身份证号码+报告机构</p>
          <p>例如：张某_225524199808041354_爱康</p>
          <p></p>
          <p>文件夹内，文件规则如下：</p>
          <p>1、文件格式必须是PDF</p>
          <p>注：单文件夹最多支持{{ maxUploadNum }}份报告</p>
        </el-card>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisibleImport = false">知道了</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="错误提示"
      :visible.sync="dialogErrorVisible"
      width="30%"
      >
      <span>{{ errorContent }}</span>
      <p class="tips">注：文件夹内存在隐藏文件或非pdf文件时，提示文件数量与实际上传文件数量可能不同，请注意</p>
      <span slot="footer" class="dialog-footer">
        <el-button style="position: relative;z-index:100;" type="primary" @click="dialogErrorVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </el-container>
</template>
<script>
const _statusList = [
  { label: "失败", value: -1 },
  { label: "上传中", value: 1 },
  { label: "上传完成（待推送至OCR）", value: 2 },
  { label: "上传至OCR", value: 3 },
  { label: "完成", value: 4 },
];
import db from "@/assets/js/localstorage";
import { isArray, dateFormat } from "@/assets/js/until.js";
import Axios from 'axios';
export default {
  data() {

    return {
      loading: false,
      tableHeight: 0,
      dialogErrorVisible: false,
      fileLoading: false,// 文件上传loading
      statusList: _statusList,
      maxUploadNum: 100, // 单个文件夹最大上传数量
      // 查询条件
      timeRange: [],
      searchBox: {
        pageSize: 10,
        pageNo: 1,
      },
      tableData: [],
      total: 0,
      path: process.env.BASE_URL,
      uploadHeader: { token: db.get("ACCESS_TOKEN") }, //上传header
      uploadFile: null, //上传后文件
      uploadTwoAction: "", //提交表单地址
      dialogVisibleImport: false, // 弹窗是否展示
      fileName: "",
      size: 20, // 限制文件大小
      suffixList: ['DS_Store',"git"], // 忽略后缀
      errorContent: "" // 错误提示
    };
  },
  created() {
    // 面包导航
    this.$root.breadList = [
      { name: "体检报告", link: "" },
      { name: "体检报告导入", link: "" },
    ];
  },
  mounted() {
    this.$nextTick(() => {
      this.listenWindow();
      this.getData()
    })
  },
  filters: {
    filterValue(text, data) {
        return (
            data.find((item) => {
                if (text == item.value) {
                    return item;
                }
            })?.label || text
        );
    },
  },
  methods: {
    //窗口改变，重新取得高度
    listenWindow() {
      this.tableHeight = this.$refs.tableBox.offsetHeight;
      window.addEventListener('resize', ()=>{
        clearTimeout(this.resizeFlag)
        this.resizeFlag = setTimeout(() => {
          this.tableHeight = this.$refs.tableBox.offsetHeight;
        }, 300);
      })
    },
    // 导入不同人文件夹
    chooseEqualFile(e) {
      let files = this.needCheckFileList(e.target.files)
      let formData = new FormData();
      console.log(files)
      this.fileName = files[0].webkitRelativePath.split('/')[0] || "";
      e.target.value = "" // 清空文件value
      for(var i = 0; i < files.length; i++) {
        let file = files[i];
        const nameCheck = /\S_[0-9]{6}[0-9]{4}((0[1-9]){1}|(1[0-2]){1})((0[1-9]{1})|(1[0-9]{1})|(2[0-9]{1})|(3[0-1]{1}))[0-9]{3}[0-9xX]{1}_\S/
        const isPDF = file.type === 'application/pdf';
        const isLt = file.size / 1024 / 1024 < this.size;
        const isName = nameCheck.test(file.name.substring(0, file.name.lastIndexOf(".")));
        if (!isPDF) {
          // this.errorContent = `文件夹内文件格式应为PDF格式`;
          // this.dialogErrorVisible = true
          this.$message.error("批量导入失败")
          setTimeout(() => {
            this.dialogVisibleImport = true;
          }, 500)
          return
        }
        if (!isLt) {
          this.errorContent = `文件夹内"${file.name}"不能超过${this.size}MB!`;
          this.dialogErrorVisible = true
          return
        }
        if (!isName) {
          // this.errorContent = `文件夹内"${file.name}"名称格式不正确，请查看帮助说明`;
          // this.dialogErrorVisible = true
          this.$message.error("批量导入失败")
          setTimeout(() => {
            this.dialogVisibleImport = true;
          }, 500)
          return
        }

        formData.append('files',files[i])
      }
      if (files.length > this.maxUploadNum) {
        this.errorContent = `文件夹内最多不得超过${this.maxUploadNum}份报告，请查看帮助说明`;
        this.dialogErrorVisible = true
        return
      }
      let url = this.getApiUrl("examReportImport")
      console.log(formData)
      this.fileUpload(url, formData) 
    },
    // 导入同一人文件夹
    chooseNoEqualFile(e) {
      let files = this.needCheckFileList(e.target.files)
      let formData = new FormData();
      console.log(files)
      this.fileName = files[0].webkitRelativePath.split('/')[0] || "";
      formData.append('directoryName',this.fileName)
      e.target.value = ""// 清空文件value
      let nameCheck = /[A-Za-z0-9\u4e00-\u9fa5]_[0-9]{6}[0-9]{4}((0[1-9]){1}|(1[0-2]){1})((0[1-9]{1})|(1[0-9]{1})|(2[0-9]{1})|(3[0-1]{1}))[0-9]{3}[0-9xX]{1}_[A-Za-z0-9\u4e00-\u9fa5]/
      const isEqualFileName = nameCheck.test(this.fileName);
      if (!isEqualFileName) {
        // this.errorContent = `文件夹"${this.fileName}"名称格式不正确，请查看帮助说明`;
        // this.dialogErrorVisible = true
        this.$message.error("批量导入失败")
        setTimeout(() => {
          this.dialogVisibleImport = true;
        }, 500)
        return
      }
      for(var i = 0; i < files.length; i++) {
        let file = files[i];
        const isPDF = file.type === 'application/pdf';
        const isLt= file.size / 1024 / 1024 < this.size;
        if (!isPDF) {
          // this.errorContent = `文件夹内文件格式应为PDF格式`;
          // this.dialogErrorVisible = true
          this.$message.error("批量导入失败")
          setTimeout(() => {
            this.dialogVisibleImport = true;
          }, 500)
          return
        }
        if (!isLt) {
          this.errorContent = `文件夹内"${file.name}"不能超过${this.size}MB!`;
          this.dialogErrorVisible = true
          return
        }

        formData.append('files',files[i])
      }
      if (files.length > this.maxUploadNum) {
        this.errorContent = `文件夹内最多不得超过${this.maxUploadNum}份报告，请查看帮助说明`;
        this.dialogErrorVisible = true
        return
      }
      let url = this.getApiUrl("examReportImport")
      console.log(formData)
      this.fileUpload(url, formData) 
    },
    // 返回需要校验上传的文件
    needCheckFileList(fileList) {
      var files = [];
      for(let i=0;i<fileList.length;i++) {
        let item = fileList[i]
        let h = item.name.substring(item.name.lastIndexOf('.') + 1)
        if(!this.suffixList.includes(h)) {
          files.push(item)
        }
      }
      return files
    },
    // 文件上传服务器
    fileUpload(url,formData) {
      console.log(formData)
      this.fileLoading =  this.$loading({
        lock: true,
        text: '文件正在上传中，请勿刷新或者关闭页面',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      Axios.post(url,formData,{
        headers: { 
          'Content-Type': 'multipart/form-data',
          'token': db.get("ACCESS_TOKEN")
        }
      }).then(res =>{
        console.log(res)
        this.fileLoading.close()
        if(res.data.code == 1) {
          this.$message.success(`文件导入成功`)
          this.getData()
        }else{
          let error = res.data.msg || "文件导入失败"
          this.$message.error(error)
        }
      }).catch(err => {
        console.log(err)
        this.fileLoading.close()
        let error = err.statusText || `文件导入失败`
        this.$message.error(error)
      });
    },
    num2Text(id, keyName) {
      if (this[keyName] && isArray(this[keyName])) {
        let findItem = this[keyName].find((o) => o.id === id);
        return findItem["label"];
      } else {
        return id;
      }
    },
    toSearch() {
      this.searchBox.pageNo = 1;
      this.getData();
    },
    getData() {
      let apiName = "examReportList";
      let data = { ...this.searchBox };
      this.axios
        .get(this.getApiUrl(apiName), {
          params: data,
        })
        .then((res) => {
          let { code, msg, data } = res;
          if (code === 1) {
            this.total = data.total;
            data.data.forEach((item) => {
              if(item.failList.length > 0 ) {
                item.failNames = item.failList.join(",<br />");
              }
            })
            this.tableData = data.data || [];
          } else {
            this.$message.warning(msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleSizeChange(val) {
      this.searchBox.pageNo = 1;
      this.searchBox.pageSize = val;
      this.getData();
    },
    handleCurrentChange(val) {
      this.searchBox.pageNo = val;
      this.getData();
    },
  },
};
</script>
<style type="text/scss" lang="scss" scoped>
.search-x {
  flex-shrink: 0;
  .search-item {
    span {
      display: inline-block;
      width: 100px;
      text-align: right;
    }
  }
}
.cont-x {
  flex: 1;
  flex-shrink: 0;
  .import-title {
    font-weight: bold;
    padding: 20px 0 10px 0;
  }
}
.upload-dom {
  display: inline-block;
  margin-right: 30px;
}
.help-content {
  display: flex;
  justify-content: space-around;
}
.file-button {
  position: relative;
  display: inline-block;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  color: #FFFFFF;
  background-color: #409eff;
  border: 1px solid #409eff;
  -webkit-appearance: none;
  text-align: center;
  box-sizing: border-box;
  outline: none;
  margin: 0;
  transition: .1s;
  font-weight: 500;
  padding: 12px 20px;
  font-size: 14px;
  border-radius: 4px;
  z-index: 2;
  margin-right: 20px;
}
.file-item {
	position: absolute;
  font-size:0;
  cursor: pointer;
	left: 0;
	right: 0;
	top: 0;
	bottom: 0;
	opacity: 0; 
  height: 100%;
  width: 100%;
}
.tips {
  position:relative;
  bottom:-68px;
  color:#cccccc;
  width: 70%;
}
</style>
